export default __webpack_public_path__ + "static/media/dp-aplicacoes-redux.50dce7eb.png";